import {SharableEntityType} from 'common/report/util/saved-entities/types';
import {getReportUrl} from 'common/report/util';

interface ValidateSharingAttributesOptions {
  ignoreEntityId?: boolean;
}

export function validateSharingAttributes({
  projectId,
  id,
  type,
  options = {
    ignoreEntityId: false,
  },
}: {
  projectId: number;
  id: number;
  type: SharableEntityType;
  options?: ValidateSharingAttributesOptions;
}) {
  return Boolean(projectId && (id || options.ignoreEntityId) && Object.values(SharableEntityType).includes(type));
}

// Generate shareable entity url
export function getEntityUrl({
  entityLink,
  projectId,
  workspaceId,
}: {
  entityLink: string;
  projectId: number;
  workspaceId: string;
}) {
  return entityLink ? window.location.origin + getReportUrl(entityLink, {projectId, workspaceId}) : ``;
}

// returns a short url for a current url in the address bar
// used in: dropdown share button and share button in report page (non-list version)
export async function createShortUrl(targetUrl: string) {
  const shortUrlFetch = await fetch(`/s/`, {
    credentials: `include`,
    method: `POST`,
    body: targetUrl,
  });

  const shortCodeResp = await shortUrlFetch.text();
  if (shortUrlFetch.status !== 200) {
    throw new Error(shortCodeResp);
  } else {
    return `${window.location.protocol}//${window.location.hostname}/s/${shortCodeResp}`;
  }
}
